import { useSelector } from "react-redux";

const useSelectors = (

) => {
    const { responsePerson, errorPerson, loadingPerson } = useSelector(
        (state: any) => ({
            responsePerson: state.Person.responsePersonById?.data,
            errorPerson: state.Person.errorPersonById,
            loadingPerson: state.Person.loadingPersonById,
        }),
    );

    const {
        responseIdentificationType,
        errorIdentificationType,
        loadingIdentificationType,
    } = useSelector((state: any) => ({
        responseIdentificationType:
            state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
        loadingIdentificationType:
            state.IdentificationType.loadingIdentificationType,
    }));
    const { responseAllQuote, errorAllQuote } = useSelector((state: any) => ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        //loadingAllQuote: state.Quote.loadingAllQuote,
    }));

    const { responseBeneficiary, errorBeneficiary, loadingBeneficiary } =
        useSelector((state: any) => ({
            responseBeneficiary: state.Beneficiary.responseBeneficiary,
            errorBeneficiary: state.Beneficiary.errorBeneficiary,
            loadingBeneficiary: state.Beneficiary.loadingBeneficiary,
        }));

    const { responseInsured, errorInsured, loadingInsured } = useSelector(
        (state: any) => ({
            responseInsured: state.Insured.responseInsured,
            errorInsured: state.Insured.errorInsured,
            loadingInsured: state.Insured.loadingInsured,
        }),
    );

    const { responseCatalogues, errorCatalogues, loadingCatalogues } = useSelector(
        (state: any) => ({
            responseCatalogues: state.Catalogues.responseCatalogues?.data,
            errorCatalogues: state.Catalogues.errorCatalogues,
            loadingCatalogues: state.Catalogues.loadingCatalogues,
        }),
    );

    const { responseCancelPolicy, errorCancelPolicy, loadingCancelPolicy } = useSelector(
        (state: any) => ({
            responseCancelPolicy: state.Policy.responseCancelPolicy,
            errorCancelPolicy: state.Policy.errorCancelPolicy,
            loadingCancelPolicy: state.Policy.loadingCancelPolicy,
        }),
    );

    const { responseCancelQuote, errorCancelQuote, loadingCancelQuote } = useSelector(
        (state: any) => ({
            responseCancelQuote: state.CancelQuote.responseCancelQuote,
            errorCancelQuote: state.CancelQuote.errorCancelQuote,
            loadingCancelQuote: state.CancelQuote.loadingCancelQuote,
        }),
    );

    return {
        responsePerson,
        errorPerson,
        loadingPerson,
        responseIdentificationType,
        errorIdentificationType,
        loadingIdentificationType,
        responseAllQuote,
        errorAllQuote,
        responseBeneficiary,
        errorBeneficiary,
        loadingBeneficiary,
        responseInsured,
        errorInsured,
        loadingInsured,
        responseCatalogues,
        errorCatalogues,
        loadingCatalogues,
        responseCancelPolicy,
        errorCancelPolicy,
        loadingCancelPolicy,
        responseCancelQuote,
        errorCancelQuote,
        loadingCancelQuote,
    }
}
export default useSelectors;